// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list_yyjQD {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  row-gap: var( --size-padMedium, 8px );
}

.editor_PN0JK {
  margin-bottom: var( --size-padMedium, 8px );
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pad_wCY8q > *:not(:last-child) {
  padding-bottom: var( --size-padLarge, 16px );
}

.pad_wCY8q {
  padding: var( --size-padMedium, 8px );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/group/search/editor/SearchEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".list {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  row-gap: var( --size-padMedium, 8px );\n}\n\n.editor {\n  margin-bottom: var( --size-padMedium, 8px );\n  height: 40vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.pad > *:not(:last-child) {\n  padding-bottom: var( --size-padLarge, 16px );\n}\n\n.pad {\n  padding: var( --size-padMedium, 8px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list_yyjQD`,
	"editor": `editor_PN0JK`,
	"pad": `pad_wCY8q`
};
export default ___CSS_LOADER_EXPORT___;
